module.exports = __webpack_public_path__ + "media/src/images/icons/gray-plus-circle-f5578a116cfafc63bc6afac471098ce9.svg";